import React from "react";
import { InputFieldType } from "../../misc/types";

const InputField = ({
  label,
  id,
  type,
  placeholder,
  value,
  checked,
  handleChange,
  options,
  disabled = false,
  additionalClassName,
  wrapperClassName = "",
}: InputFieldType) => {
  return (
    <>
      {(type === "text" || type === "number") && (
        <div className={wrapperClassName}>
          <label
            htmlFor={id}
            className="block text-sm font-semibold text-valley-gray "
          >
            {label}
          </label>
          <input
            type={type}
            id={id}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            className={`border border-gray-200 py-1 px-2 w-full focus:outline-none bg-blue-100 placeholder-gray-700 text-black ${additionalClassName}`}
          />
        </div>
      )}

      {type === "textarea" && (
        <div className="flex flex-col">
          {Boolean(label) && (
            <label
              htmlFor={id}
              className="block text-sm font-semibold text-gray-700"
            >
              {label}
            </label>
          )}
          <textarea
            id={id}
            value={value}
            onChange={handleChange}
            className={`border border-gray-200 p-3 mt-2 w-full focus:outline-none placeholder-gray-700 h-[100px] text-black ${additionalClassName}`}
            placeholder={placeholder}
            disabled={disabled}
          />
        </div>
      )}

      {type === "checkbox" && (
        <div className="flex items-center">
          <input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={handleChange}
            className="mr-2 h-5 w-5 border-gray-300 text-blue-500 focus:ring-0 bg-blue-100"
          />
          <label htmlFor={id} className="text-sm text-gray-700">
            {label}
          </label>
        </div>
      )}

      {type === "select" && (
        <div className={wrapperClassName}>
          {Boolean(label) && (
            <label
              htmlFor={id}
              className="block text-sm font-semibold text-valley-gray"
            >
              {label}
            </label>
          )}
          <select
            id={id}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            className={`border border-gray-200 rounded-md py-1 px-2 w-full focus:outline-none bg-blue-100  placeholder-gray-700 text-black ${additionalClassName}`}
          >
            <option value="">Выберите...</option>
            {options?.map((o) => (
              <option value={o.value}>{o.label || o.value}</option>
            ))}
          </select>
        </div>
      )}
    </>
  );
};

export default InputField;
